/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_Payment_Validation_Confirmed_Upfront_LockedInputs */

const en_case_payment_validation_confirmed_upfront_locked = /** @type {(inputs: Case_Payment_Validation_Confirmed_Upfront_LockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A confirmed upfront amount and date cannot be changed.`)
};

const pt_br2_case_payment_validation_confirmed_upfront_locked = /** @type {(inputs: Case_Payment_Validation_Confirmed_Upfront_LockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O valor e a data de um pagamento à vista confirmado não podem ser alterados.`)
};

/**
* | output |
* | --- |
* | "A confirmed upfront amount and date cannot be changed." |
*
* @param {Case_Payment_Validation_Confirmed_Upfront_LockedInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_payment_validation_confirmed_upfront_locked = /** @type {((inputs?: Case_Payment_Validation_Confirmed_Upfront_LockedInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Payment_Validation_Confirmed_Upfront_LockedInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_payment_validation_confirmed_upfront_locked(inputs)
	return pt_br2_case_payment_validation_confirmed_upfront_locked(inputs)
});